// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__EH182","secure":"styles_secure__SKxHi"};